import { Trash } from "lucide-react";
import { Button, DefaultTooltip } from "twyne-new.ui";

import ConfirmationPopover from "@/components/ConfirmationPopover";

export default function DeleteFormatter({ data, isEditing, isDefault, onDelete }) {
  const { id } = data

  if (isEditing || isDefault) {
    return null;
  }

  return <ConfirmationPopover
    title="Delete Version"
    target={<DefaultTooltip content="Delete" side="top">
      <Button id={`btn-delete-${id}`} color="danger" variant="outline" size="sm">
        <Trash size={16} />
      </Button>
    </DefaultTooltip>}
    >
      <div>
        <div className="mb-2 font-bold">Are you sure you want to delete this version?</div>
        <Button color="danger" className="mt-2 w-full flex justify-center" onClick={() => onDelete(data)}>
          Yes, I am sure
        </Button>
      </div>
  </ConfirmationPopover>
}
